<template>
    <div>
        <div class="dateTile">
            <span style="display: inline-block;margin-right: 24px">时间：</span>

            <div class="tab" v-if="navList">
                <div class="tab_item" :class="{is_active:index==actIndex}" @click="tabChange(index)" v-for="(item,index) in navList" :key="index">{{item.beginTime}}</div>
            </div>
        </div>



        <div class="list" v-for="(item1,index1) in list" :key="index1">
        <div style="padding:20px ">
            <div class="creatTime">
                {{item1.showTime}}
            </div>
            <div class="title" @click="imgModel=true;visible=true;imgurl=item1.detailedInformation">
               {{item1.scheduleName}}
            </div>
            <div class="company">
               <span>
                  {{item1.scheduleAddress}}
               </span>
            </div>
        </div>
        <div class="baoming" v-if="item1.preRegLink" @click="gopreRegLink(item1.preRegLink)">
            <span>
                立即报名
            </span>
        </div>
    </div>


        <div style="margin-bottom: 70px">

        </div>
        <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;margin-bottom:96px;text-align: center;">
            <Page
                    show-total
                    show-elevator
                    :page-size="pageSize"
                    :current="pageIndex"
                    :total="totalCount"
                    @on-change="changePage"
                    @on-page-size-change="changePageSize"
            />
        </div>
        <iModal
                title="查看图片"
                v-model="visible"
                class-name="vertical-center-modal"
                width="600px"
                footer-hide
                v-if="imgurl"
        >
            <div style="width:100%;height:100%;">
                <img style="width:100%;" :src="imgurl" />
            </div>
        </iModal>
    </div>

</template>

<script>
    import { mapActions } from "vuex";
    export default {
        name: "meeting",
        data() {
            return {
                list: [],
                navList:[],
                actIndex:0,
                pageIndex:1,
                pageSize:10,
                totalCount:0,
                imgModel:'',
                imgurl:'',
                visible:false,
                date:'2020-10-19'
            };
        },
        components: {},
        computed: {},
        created() {
            this.init();
        },
        methods: {
            ...mapActions({
                getContactUsForGroup: "contactUs/getContactUsForGroup"
            }),
             init() {


                 this.$http.get(`/api/OfflineMeeting/GetOfflineMeetingTime`, this.$store.state.header)
                     .then(res=>{
                         if(res.status === 200 ){
                                res.data.forEach(c=>{
                                    c.beginTime= c.beginTime.substring(0,10)
                                })
                             this.navList=res.data
                             this.date=this.navList[0].beginTime
                             console.log(this.date,'获取成功s')
                         }
                     })

                 let   body={
                     PageSize: this.pageSize,
                     PageIndex: this.pageIndex,
                     Wheres: {
                         type: 0,
                         wheres: {
                             WhereGroupOperator: 0,
                             Predicates: [
                                 {
                                     type: 1,
                                     wheres: {
                                         WhereOperator: 0,
                                         Label: "BeginTime",
                                         Value:  this.date
                                     }
                                 }
                             ]
                         }
                     }
                 }
                 this.$http.post(`/api/OfflineMeeting/GetOfflineMeetingList`,body, this.$store.state.header)
                    .then(res=>{

                        if(res.status === 200 ){
                            this.list=res.data.items
                            this.pageSize = res.data.pageSize;
                            this.pageIndex =res.data.pageIndex;
                            this.totalCount = res.data.totalCount;

                        }
                    })
            },
            tabChange(i){
                if(this.actIndex==i){
                    return
                }
                this.actIndex=i;
                this.date=this.navList[i].beginTime
                this.init()

            },
            changePage(e) {
                this.pageIndex = e;
                this.init();
            },
            changePageSize(e) {
                this.pageSize = e;
                this.init();
            },
            gopreRegLink(href){
                window.open(href)
            }
        }
    };
</script>

<style scoped lang="scss">
    .dateTile{
        background-color: #fff;
        width: 1200px;
        padding: 20px;
        display: flex;
        align-items: center;
    }
    .tab_item{
        display: inline-block;
        margin-right: 40px;
        cursor: pointer;
        &.is_active{
            color: #d13119;
        }
    }
    .list{
        width: 1200px;
        background-color: #fff;
        display: flex;
        align-items: center;
        margin-top: 20px;
        .creatTime{
            font-size: 14px;
            color: #666;
        }
        .title{
            width: 980px;
            font-size: 16px;
            font-weight: bold;
            color: #333;
            margin: 18px 0;
        }
        .company{
            span{
                font-size: 14px;
                color: #666;
                display: block;
                line-height: 26px;
            }
        }
        .baoming{
            width: 160px;
            height: 46px;
            background-color: #024c8b;
            display: flex;
            align-content: center;
            justify-content: center;
            span{
                font-size: 16px;
                color: #fff;
                line-height: 46px;
            }
        }
    }
</style>
